<template>
    <div
        class="aon-container"
        :class="[{ 'page-padding': addPagePadding }]"
    >
        <slot></slot>
    </div>
</template>

<script setup>

const props = defineProps({
    fluid: {
        type: Boolean,
        default: true,
    },
    addPagePadding: {
        type: Boolean,
        default: false,
    }
})
</script>

<script>
    export default {
        name: 'AonContainer'
    }
</script>

<style lang="scss">
@import '../../../sass/grid.scss';
@import '../../../sass/responsive.scss';

.aon-container {
    width: 100%;
    max-width: 1600px;
    padding-right: 0;
    padding-left: 0;
    margin: auto;

    @include overSized {
        max-width: none;
    }

    &.page-padding {
        padding-right: 40px;
        padding-left: 40px;
    }
}
</style>
